import {findClosestElementByClass} from "../helpers/dom/closest";

export const eDropdown = {
    init: function ($root = document) {
        // console.log('eDropdown => INIT')
        const dropdowns = [...$root.querySelectorAll(".ecommerce-form__dropdown")];

        if (dropdowns.length === 0) return;
        dropdowns.forEach(drop => {
            eDropdown.createDropdown(drop);
        });
    },

    createDropdown: function(container) {
        const options = [...container.querySelectorAll("option")];
        const fakeDropdown = container.querySelector(".dropdownContainer");
		fakeDropdown.innerHTML = '';		
        options.forEach(o => {
            eDropdown.appendHTML(o, fakeDropdown, container);
        });
    },

    appendHTML: function(option, fakeDropdown, container) {
		const fakeOption = eDropdown.getDropdownStructure(option);		
        fakeDropdown.appendChild(fakeOption);
        eDropdown.addChangeOptionListener(container, fakeOption, fakeDropdown);
    },

    getDropdownStructure: function(option) {
        let div = document.createElement("div");
        div.className += "offer-dropdown__option dropdownOption";
        let span = document.createElement("button");
        span.setAttribute('type', 'button');
        span.className += "offer-dropdown__option-link dropdownLink";
        span.innerHTML = option.innerHTML;
        let att = document.createAttribute("data-option");
        att.value = option.value;
        div.setAttributeNode(att);
        div.appendChild(span);
        return div;
    },

    addChangeOptionListener: function(container, fakeOption, fakeDropdown) {
        fakeOption.addEventListener("click", function() {
			const selectedValue = fakeOption.getAttribute("data-option");
            eDropdown.setRealDropdownValue(container, selectedValue)
            eDropdown.setFakeDropdownValue(fakeDropdown, this, container);

            if (container.classList.contains("offerSwitch"))
                eDropdown.showRadio(fakeOption);
        });
    },

    setRealDropdownValue: function(container, selectedValue) {
		container.querySelector("select").value = selectedValue;
    },

    setFakeDropdownValue: function(fakeDropdown, selectedOption, container) {
        const selectedOptionValue = selectedOption.getAttribute("data-option");
        const selectedOptionText = selectedOption.querySelector("button").innerHTML;
        const firstFakeDropdownOption = container.querySelector(".dropdownOption");
        firstFakeDropdownOption.setAttribute("data-option", selectedOptionValue);
        firstFakeDropdownOption.querySelector("button").innerHTML = selectedOptionText;
    },

    showRadio: function(fakeOption) {
        const option = fakeOption.getAttribute("data-option");

        if (option ==  null) return;
        const container = findClosestElementByClass(fakeOption, "form__container");
        const radio = [...container.querySelectorAll("[data-drop-value]")];

        radio.forEach(r => {
            if(r.getAttribute("data-drop-value") == option) {
                r.style.display = "block";
            }
            else {
                r.style.display = "none";
            }
        })
    }
}
